<div class="full-height-scroll-container">
    <app-table
        #appTable
        [tableService]="profilerService"
        [buttons]="profilerService.buttons"
        tableAutoHeight
        (edit)="onRowClick($event)"
        (dblClickRow)="onRowClick($event)"
    >
        <h2 fui-table-header-title>
            <span [innerHTML]="appService.sideMenuTitle | truncate: 50"></span>
        </h2>
    </app-table>
</div>
